import alert from '@jetbrains/ring-ui/components/alert-service/alert-service'
import * as React from 'react'
import {useMutation} from 'react-relay'

import type {AgentPoolPageMoveAgentToAgentPoolMutation} from '../../AgentPoolPage/__generated__/AgentPoolPageMoveAgentToAgentPoolMutation.graphql'
import type {AgentPoolPageMoveCloudImageToAgentPoolMutation} from '../../AgentPoolPage/__generated__/AgentPoolPageMoveCloudImageToAgentPoolMutation.graphql'
import {
  moveAgentToAgentPool,
  moveCloudImageToAgentPool,
} from '../../AgentPoolPage/AgentPoolPage.queries'

export function useMoveAgentToAgentPool(agentRawId: string, agentPoolRawId: string) {
  const [commit, isInFlight] =
    useMutation<AgentPoolPageMoveAgentToAgentPoolMutation>(moveAgentToAgentPool)
  const move = React.useCallback(() => {
    commit({
      variables: {agentRawId, agentPoolRawId},
      onCompleted: (response, errors) => {
        if (errors != null) {
          errors.forEach(error => alert.error(error.message))
        }
      },
      onError: error => {
        alert.error(error.message)
      },
    })
  }, [agentRawId, agentPoolRawId, commit])

  return [move, isInFlight]
}

export function useMoveCloudImageToAgentPool(agentTypeRawId: string, agentPoolRawId: string) {
  const [commit, isInFlight] =
    useMutation<AgentPoolPageMoveCloudImageToAgentPoolMutation>(moveCloudImageToAgentPool)
  const move = React.useCallback(() => {
    commit({
      variables: {agentTypeRawId, agentPoolRawId},
      onCompleted: (response, errors) => {
        if (errors != null) {
          errors.forEach(error => {
            alert.error(error.message)
          })
        }
      },
      onError: error => {
        alert.error(error.message)
      },
    })
  }, [commit, agentTypeRawId, agentPoolRawId])
  return [move, isInFlight]
}
